import { Shipment } from '../../../models/Shipment/Shipment.js';
import { ShipmentSource } from '../../../models/Shipment/ShipmentSource.js';

// TODO (improve tests) FRON-91

class Shipments {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getShipments() {
    return this.apiClient.get('v1/shipments').then(response => response.data.map(Shipment.createFromResponse));
  }
  getShipment(shipmentReference) {
    return this.apiClient.get(`v1/shipments/${shipmentReference}`).then(response => Shipment.createFromResponse(response.data));
  }
  getShipmentsByReference(references) {
    return this.apiClient.post('v1/shipments/by-client-references', {
      references
    }).then(response => response.data.map(Shipment.createFromResponse));
  }
  createShipment(shipment) {
    return this.apiClient.post('v1/shipments', shipment.getCreatePayload()).then(response => response.data);
  }
  updateShipment(shipment) {
    return this.apiClient.put(`v1/shipments/${shipment.packlinkReference}`, shipment.getUpdatePayload()).then(response => response.data);
  }
  updateShipments(shipments) {
    return this.apiClient.put('v1/shipments-bulk', shipments.map(shipment => shipment.getUpdatePayload())).then(_ref => {
      let {
        data
      } = _ref;
      return {
        shipmentsUpdated: data.shipments_updated,
        shipmentsFailed: data.shipments_failed
      };
    });
  }
  deleteShipments(references) {
    return this.apiClient.post('v1/shipments-bulk/delete', {
      references
    }).then(response => response.data);
  }
  getLabels(references) {
    return this.apiClient.post('v1/shipments/labels_merge', {
      references
    }).then(response => response.data.id);
  }
  getShipmentsSources(inbox) {
    return this.apiClient.get(`v1/shipments/${inbox}/sources`).then(response => response.data.sources.map(ShipmentSource.createFromResponse));
  }
  getShipmentsCarrierNames(inbox) {
    return this.apiClient.get(`v1/shipments/${inbox}/carrier/names`).then(response => response.data);
  }
  requestReport(params) {
    return this.apiClient.post('v1/shipments/report', params).then(response => response.data);
  }
  createReturnShipment(shipmentReference) {
    return this.apiClient.post(`v1/shipments/${shipmentReference}/return`).then(response => response.data.shipment_reference);
  }
  cancelShipment(shipmentReference, reason) {
    return this.apiClient.post(`v1/shipments/${shipmentReference}/request-cancellation`, {
      reason
    }).then(response => response.data);
  }
  insureShipments(references) {
    return this.apiClient.post('v1/shipments/insurance', {
      shipments: references
    }).then(response => response.data);
  }
}

export { Shipments };
//# sourceMappingURL=Shipments.js.map
